'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ElementDragPreview = require('./ElementDragPreview');

var _ElementDragPreview2 = _interopRequireDefault(_ElementDragPreview);

var _dragAndDropUtils = require('../../utils/dnd/dragAndDropUtils');

var _cssUtil = require('../../utils/cssUtil');

require('./ElementDragPreviewPositioner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Utils


// Styles


var getTranslation = function getTranslation(props) {
    var offset = (0, _dragAndDropUtils.getElementOffset)(props);
    return (0, _cssUtil.getTranslationStyles)(offset);
};

var ElementDragPreviewPositioner = function (_React$Component) {
    _inherits(ElementDragPreviewPositioner, _React$Component);

    function ElementDragPreviewPositioner() {
        _classCallCheck(this, ElementDragPreviewPositioner);

        return _possibleConstructorReturn(this, (ElementDragPreviewPositioner.__proto__ || Object.getPrototypeOf(ElementDragPreviewPositioner)).apply(this, arguments));
    }

    _createClass(ElementDragPreviewPositioner, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                gridSize = _props.gridSize,
                currentBoardId = _props.currentBoardId;


            return _react2.default.createElement(
                'div',
                { className: 'ElementDragPreviewPositioner', style: getTranslation(this.props) },
                _react2.default.createElement(_ElementDragPreview2.default, { ref: 'elementDragPreview',
                    currentBoardId: currentBoardId,
                    element: element,
                    isPresentational: true,
                    gridSize: gridSize })
            );
        }
    }]);

    return ElementDragPreviewPositioner;
}(_react2.default.Component);

ElementDragPreviewPositioner.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired
};

exports.default = ElementDragPreviewPositioner;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/ElementDragPreviewPositioner.js
// module id = 1969
// module chunks = 0